import { useMemo } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'
import { interWbNavigate } from 'inter-webview-bridge'
import { useGlobalContext } from 'contexts/global'
import { useGetUserInfo } from 'hooks/useGetUserInfo'
import { validateIsKidsAccount } from 'utils'

function useBasePage() {
  const { isError, isLoading, info } = useGetUserInfo()
  const navigate = useNavigate()
  const location = useLocation()

  const { loadingGlobal, headerPage } = useGlobalContext()

  const goBack = () => {
    if (location?.pathname === '/') {
      interWbNavigate.requestGoBack()
    } else {
      navigate(-1)
    }
  }

  const onContinue = () => interWbNavigate.requestGoBack()

  const loading = useMemo(() => loadingGlobal && isLoading, [loadingGlobal, isLoading])

  const isKidsAccount = useMemo(() => {
    const birthDate = info?.birthDate

    return validateIsKidsAccount(birthDate)
  }, [info])

  return {
    isLoading: loading,
    isError,
    headerPage,
    isKidsAccount,
    goBack,
    onContinue,
  }
}

export { useBasePage }
